import { render, staticRenderFns } from "./MusteriForm.vue?vue&type=template&id=90527b50&scoped=true&"
import script from "./MusteriForm.vue?vue&type=script&lang=js&"
export * from "./MusteriForm.vue?vue&type=script&lang=js&"
import style0 from "./MusteriForm.vue?vue&type=style&index=0&id=90527b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90527b50",
  null
  
)

export default component.exports